import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TimesheetModelEnchanced } from '@reducers/orm/timesheet/timesheet.model';
import { TimesheetService } from '@reducers/orm/timesheet/timesheet.service';
import { ButtonComponent, IconAnchorButtonComponent } from '@sb/ui/button';
import { SbDialogService } from '@sb/ui/dialog';
import { IconComponent } from '@sb/ui/icon';
import { LaddaDirective } from '@sb/ui/ladda';
import { filter, switchMap } from 'rxjs';

import { TimesheetTotalComponent } from '../timesheet-total/timesheet-total.component';

@Component({
  selector: 'timesheet-total-timesheet-clocked-in',
  templateUrl: './timesheet-total-timesheet-clocked-in.component.html',
  imports: [
    ButtonComponent,
    IconAnchorButtonComponent,
    LaddaDirective,
    IconComponent,
    TimesheetTotalComponent,
    TranslatePipe,
    RouterModule,
  ],
})
export class TimesheetTotalTimesheetClockedInComponent {
  private timesheetService = inject(TimesheetService);
  private dialog = inject(SbDialogService);
  private translate = inject(TranslateService);

  @Input()
  timesheet: TimesheetModelEnchanced;
  @Input()
  time: number;
  @Input()
  salary: number;
  @Input()
  showSalary: boolean;
  @Input()
  coc: number;
  @Input()
  showCoc = false;

  handleClockOut(): void {
    if (!this.timesheet.canClockOut && !this.timesheet.saving) {
      return;
    }

    void this.dialog
      .openConfirm({
        type: 'danger',
        title: this.translate.instant('Clock Out'),
        description: this.translate.instant(
          'Clocking out creates a timesheet with the recorded start time, end time, and breaks.',
        ),
        primary: {
          text: this.translate.instant('Clock out'),
        },
      })
      .closed.pipe(
        filter((result) => result?.confirmed),
        switchMap(() => this.timesheetService.clockOut(this.timesheet.id, this.timesheet.user_id)),
      )
      .subscribe();
  }
}
